import { z } from "zod";
import { Literal } from "./pipeline";

// §3.6 Pricing — Engine über den aufgelösten Plan (D17/D31/D34/D39/D44) ─────────

export const CostUnit = z.enum(["flat", "image", "second", "frame", "megapixel"]);
export type CostUnit = z.infer<typeof CostUnit>;

export const CostTerm = z.object({
  perUnit: z.number(),
  unit: CostUnit,
  when: z.object({ param: z.string(), eq: Literal }).optional(),
});
export type CostTerm = z.infer<typeof CostTerm>;

export const CostRule = z.union([z.number(), z.object({ sum: z.array(CostTerm) })]);
export type CostRule = z.infer<typeof CostRule>;

export const PriceBook = z.object({
  version: z.number().int(),
  // Key 'id' | 'id@version' | 'id#provider' | 'id@version#provider' (D101) — die Engine
  // löst provider-bewusst auf (Kette in resolveCostRule), das Schema bleibt ein Record.
  capabilityCost: z.record(z.string(), CostRule),
  toolBaseFee: z.record(z.string(), z.number()),
});
export type PriceBook = z.infer<typeof PriceBook>;

/**
 * Metriken, die ein Knoten der Pricing-Engine zur CostTerm-Auswertung beisteuert
 * (z.B. { second: 4, image: 2, megapixel: 1.3 }). Werden beim Build aus den
 * eingefrorenen params/Provider-Limits abgeleitet (Single-Pass, D34).
 */
export type NodeMetrics = Partial<Record<CostUnit, number>>;
